import { MultiSelect, Select } from "@mantine/core";
import React from "react";

const CustomSelect = ({
  onChange,
  value,
  name,
  placeholder,
  options,
  mode,
  style,
  isLoading,
}) => {
  const data = (options || []).map((opt) => ({
    value: String(opt.value),
    label: opt.label,
  }));

  if (mode === "multiple" || mode === "tags") {
    return (
      <MultiSelect
        label={name}
        data={data}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        searchable
        styles={{ label: { fontWeight: 600 } }}
        style={style}
      />
    );
  }

  return (
    <Select
      label={name}
      data={data}
      value={value != null ? String(value) : null}
      onChange={onChange}
      placeholder={placeholder}
      searchable
      clearable
      styles={{ label: { fontWeight: 600 } }}
      style={style}
    />
  );
};

export default CustomSelect;
